import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    Input,
    OnDestroy,
    ViewChild,
    inject,
} from '@angular/core';
import EmblaCarousel, { EmblaCarouselType, EmblaOptionsType } from 'embla-carousel';
import { ICustomWindow, WindowRefService } from '../_shared/services/window-ref.service';

@Component({
    standalone: true,
    selector: 'sirius-carousel',
    templateUrl: './carousel.component.html',
    styleUrl: './carousel.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        '[class.is-clipped]': 'clipViewport',
    },
})
// Internal to SliderComponent: render via <sirius-slider>, not <sirius-carousel> directly.
export class CarouselComponent implements OnDestroy, AfterViewInit {
    private _windowRef = inject(WindowRefService);

    @Input() startIndex = 0;
    @Input() options: EmblaOptionsType = {};

    /** Clips slides at the viewport edge. Full-width sliders have nothing to bleed into. */
    @Input() clipViewport = false;

    @ViewChild('slider', { static: true }) slider!: ElementRef<HTMLElement>;
    @ViewChild('viewport', { static: true }) viewport!: ElementRef<HTMLElement>;
    @ViewChild('container', { static: true }) container!: ElementRef<HTMLElement>;

    carousel?: EmblaCarouselType;

    private get Window(): ICustomWindow | undefined {
        return this._windowRef.NativeWindow;
    }

    ngAfterViewInit(): void {
        if (!this.Window) return;

        this.carousel = EmblaCarousel(this.viewport.nativeElement, this.options);

        this.viewport.nativeElement.blur();
    }

    ngOnDestroy(): void {
        this.carousel?.destroy();
    }
}
